import axios from 'axios'

/*
 * Saving the "bookings to complete" rows.
 *
 * Was an Angular factory taking `$http` (step 35 of #614). It uses axios now.
 */
const incompleteBookingsService = {
  updateBookings: async bookingHeaders => {
    return axios.post('/api/job/booking', bookingHeaders)
  },
}

export default incompleteBookingsService
